import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseA4 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A4.json"}/>

export default LicenciaClaseA4;
